import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { includes } from "lodash";

import TextField from "@material-ui/core/TextField";

import colors from "../../assets/style/colors";

const styles = {
  textField: {
    margin: 0,
    backgroundColor: colors.white,
  },
  input: {
    height: "36px",
  },
  inputElement: {
    padding: "9.5px 10px",
  },
  inputSize: {
    fontSize: "0.875em",
    backgroundColor: colors.white,
  },
};

const CustomInput = (props) => {
  const { classes, permission = false, reservation = false} = props;
  if (reservation) {
    return (
      <TextField
        error={props.error || false}
        helperText={props.helperText}
        className={classes.textField}
        name={
          includes(props.name, "name")
            ? Math.round(Math.random() * 100).toString()
            : props.name
        }
        id={props.id || props.name}
        style={{width:180}}
        disabled={permission}
        multiline={props.multiline || false}
        rows={props.rows || null}
        value={props.value}
        onChange={props.onChange}
        onBlur={props.onBlur}
        variant="outlined"
        margin="dense"
        type={props.type || "text"}
        autoFocus={props.autoFocus}
        placeholder={props.placeholder}
        InputProps={{
          onBlur: props.onBlur,
          classes: { input: classes.inputSize },
          className: !props.multiline ? classes.input : "",
          startAdornment: props.startAdornment,
          endAdornment: props.endAdornment,
          style: {
            height: props.height || "",
            alignItems: props.multiline ? "flex-start" : "center",
          },
        }}
        inputProps={{
          className: !props.multiline ? classes.inputElement : "",
        }}
        FormHelperTextProps={{ ...props.FormHelperTextProps }}
        autoComplete={props.autocomplete || "off"}
        onKeyDown={props.onKeyDown}
      />
    );
  } else {
    return (
      <TextField
        error={props.error || false}
        helperText={props.helperText}
        className={classes.textField}
        name={
          includes(props.name, "name")
            ? Math.round(Math.random() * 100).toString()
            : props.name
        }
        id={props.id || props.name}
        fullWidth
        disabled={permission}
        multiline={props.multiline || false}
        rows={props.rows || null}
        value={props.value}
        onChange={props.onChange}
        // onBlur={props.onBlur}
        variant="outlined"
        margin="dense"
        type={props.type || "text"}
        autoFocus={props.autoFocus}
        placeholder={props.placeholder}
        InputProps={{
          onBlur: props.onBlur,
          classes: { input: classes.inputSize },
          className: !props.multiline ? classes.input : "",
          startAdornment: props.startAdornment,
          endAdornment: props.endAdornment,
          style: {
            height: props.height || "",
            alignItems: props.multiline ? "flex-start" : "center",
          },
        }}
        inputProps={{
          className: !props.multiline ? classes.inputElement : "",
          step: props.step || "",
        }}
        FormHelperTextProps={{ ...props.FormHelperTextProps }}
        autoComplete={props.autocomplete || "off"}
        onKeyDown={props.onKeyDown}
      />
    );
  }

};

CustomInput.propTypes = {
  error: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  multiline: PropTypes.bool,
  height: PropTypes.string,
  rows: PropTypes.number,
  type: PropTypes.string,
  step: PropTypes.string,
  startAdornment: PropTypes.any,
  endAdornment: PropTypes.any,
};

export default withStyles(styles)(CustomInput);
